import { render, staticRenderFns } from "./ResultSelection.vue?vue&type=template&id=1b921602"
import script from "./ResultSelection.vue?vue&type=script&lang=js"
export * from "./ResultSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports